// Typelizer digest c3a79cd82bc968c8f6ee7ce1ca3feacd
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/invoice_templates/:invoice_template_id/drafts */
  create: (
    params: { invoiceTemplateId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/invoice_templates/:invoice_template_id/drafts', params, options),
    method: 'post',
  }),
}
